export interface ChecklistData {
  account_created: boolean;
  add_members: boolean;
  broadcast_id: number;
  complete: boolean;
  completed_steps: number;
  confirm_access: boolean;
  create_access_group: boolean;
  create_invite_link: boolean;
  create_spaces: boolean;
  customize_branding: boolean;
  import_email_list: boolean;
  initial_focused_step_key: StepKey | null;
  personalize_profile: boolean;
  progress: number;
  send_launch_announcement: boolean;
  setup_payments: boolean;
  total_steps: number;
}

export type SectionKey =
  | "complete_profile"
  | "design_community"
  | "setup_access"
  | "launch_community";

export const stepKeys = {
  account_created: "account_created",
  personalize_profile: "personalize_profile",
  customize_branding: "customize_branding",
  create_spaces: "create_spaces",
  confirm_access: "confirm_access",
  create_access_group: "create_access_group",
  setup_payments: "setup_payments",
  add_members: "add_members",
  create_invite_link: "create_invite_link",
  import_email_list: "import_email_list",
  send_launch_announcement: "send_launch_announcement",
} as const;

export type StepKey = (typeof stepKeys)[keyof typeof stepKeys];

export interface SectionConfig {
  key: SectionKey;
  steps: readonly StepKey[];
  title: string;
}

export type StepAction = () => void | Promise<void>;

export const communityAccessOptions = {
  private: "private",
  public: "public",
} as const;

export type CommunityAccess =
  (typeof communityAccessOptions)[keyof typeof communityAccessOptions];
